export default __webpack_public_path__ + "static/media/logoydireccion.c26f348c.png";